import { render, staticRenderFns } from "./todayPlayerPointSpecial4.vue?vue&type=template&id=4714020d&scoped=true&"
import script from "./todayPlayerPointSpecial4.vue?vue&type=script&lang=js&"
export * from "./todayPlayerPointSpecial4.vue?vue&type=script&lang=js&"
import style0 from "./todayPlayerPointSpecial4.vue?vue&type=style&index=0&id=4714020d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4714020d",
  null
  
)

export default component.exports